import React, { useContext, useEffect, useState } from "react";
import CardSection from "../../../../../../components/ui/card/CardSection";
import MolGrid, { Column } from "@moltech/molui/molgrid";
import Buttons from "../../../../../../components/ui/button/Buttons";
import CustomCenterModel from "../../../../../../components/ui/customCenterModel/CustomCenterModel";
import { AppIcons } from "../../../../../../data/appIcons";
import { useAddPendingContractScopeMutation, useDeletePendingContractScopeMutation, useDeletePendingContractScopeTypeMutation, useLazyGetPendingContractScopesAvailableQuery, useLazyGetPendingContractScopesQuery, usePendingContractScopeEditSerialNumberMutation } from "../../../../../../app/services/pendingContractAPI";
import { PendingContractContext } from "../../../../../../utils/context/PendingContractContext";
import ToastService from "../../../../../../services/toastService/ToastService";
import AddPendingContractScopes from "./features/AddPendingContractScope";
import SwalAlert from "../../../../../../services/swalService/SwalService";
import FormInputFields from "../../../../../../components/finalForms/formFields/FormInputFields";
import { useLazyCheckScopeSerialNumberExistsQuery } from "../../../../../../app/services/contractAPI";

const Scopes = () => {
  const { confirm, warning } = SwalAlert();
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isCentralModel, setIsCentralModel] = useState(false);
  const { pendingContractId } = useContext(PendingContractContext) || {};
  const [contractScopesData, setContractScopesData] = useState([]);
  const [availableScopesData, setAvailableScopesData] = useState([]);
  const [selectedCheckboxRows, setSelectedCheckboxRows] = useState([]);
  const [editRowData, setEditRowData] = useState(null);
  const [serialNumber, setSerialNumber] = useState("");

  const [getPendingContractScopesAvailable, {
    isFetching: isPendingContractScopesAvailableFetching,
    isSuccess: isPendingContractScopesAvailableFetched,
    data: PendingContractScopesAvailableData,
  },] = useLazyGetPendingContractScopesAvailableQuery();

  const [getPendingContractScopes, {
    isFetching: isPendingContractScopesFetching,
    isSuccess: isPendingContractScopesFetched,
    data: PendingContractScopesData,
  },] = useLazyGetPendingContractScopesQuery();

  const [addPendingContractScope, {
    isSuccess: isPendingContractScopeAdded,
    data: PendingContractScopeaddData,
  },] = useAddPendingContractScopeMutation();

  const [deletePendingContractScope, {
    isSuccess: deletePendingContractScopeFetching,
    data: deletePendingContractScopeData
  }] = useDeletePendingContractScopeMutation();

  const [deletePendingContractScopeType, {
    isSuccess: deletePendingContractScopeTypeFetching,
    data: deletePendingContractScopeTypeData,
  }] = useDeletePendingContractScopeTypeMutation();

  const [checkScopeSerialNumberExists] = useLazyCheckScopeSerialNumberExistsQuery();

  const [pendingContractScopeEditSerialNumber, {
    isSuccess: ispendingContractScopeEditSerialNumberSuccess,
    data: pendingContractScopeEditSerialNumberData,
  }] = usePendingContractScopeEditSerialNumberMutation();


  useEffect(() => {
    if (pendingContractId) {
      getPendingContractScopesAvailable(pendingContractId);
      getPendingContractScopes(pendingContractId);
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pendingContractId, isPendingContractScopeAdded, deletePendingContractScopeFetching, deletePendingContractScopeTypeFetching]);

  useEffect(() => {
    if (!isPendingContractScopesFetching && isPendingContractScopesFetched && PendingContractScopesData) {
      if (PendingContractScopesData) {
        setContractScopesData(PendingContractScopesData);
      }
    }
  }, [isPendingContractScopesFetching, isPendingContractScopesFetched, PendingContractScopesData])

  useEffect(() => {
    if (!isPendingContractScopesAvailableFetching && isPendingContractScopesAvailableFetched && PendingContractScopesAvailableData) {
      if (PendingContractScopesAvailableData) {
        setAvailableScopesData(PendingContractScopesAvailableData);
      }
    }
  }, [isPendingContractScopesAvailableFetching, isPendingContractScopesAvailableFetched, PendingContractScopesAvailableData])

  useEffect(() => {
    if (deletePendingContractScopeTypeFetching && deletePendingContractScopeTypeData) {
      if (deletePendingContractScopeTypeData) {
        ToastService.success(deletePendingContractScopeTypeData?.errorMessage);
      }
    }
  }, [deletePendingContractScopeTypeFetching, deletePendingContractScopeTypeData])

  useEffect(() => {
    if (ispendingContractScopeEditSerialNumberSuccess && pendingContractScopeEditSerialNumberData) {
      ToastService.success(pendingContractScopeEditSerialNumberData.errorMessage);
      handleCloseCentralModel();
      getPendingContractScopes(pendingContractId);
    }
  }, [ispendingContractScopeEditSerialNumberSuccess, pendingContractScopeEditSerialNumberData]);

  useEffect(() => {
    if (isPendingContractScopeAdded && PendingContractScopeaddData) {
      if (PendingContractScopeaddData) {
        ToastService.success(PendingContractScopeaddData?.errorMessage);
        setSelectedCheckboxRows([]);
      }
    }
  }, [isPendingContractScopeAdded, PendingContractScopeaddData])

  useEffect(() => {
    if (deletePendingContractScopeFetching && deletePendingContractScopeData) {
      if (deletePendingContractScopeData) {
        ToastService.success(deletePendingContractScopeData?.errorMessage);
      }
    }
  }, [deletePendingContractScopeFetching, deletePendingContractScopeData])


  const handleAssignClick = () => {
    if (selectedCheckboxRows && selectedCheckboxRows.length > 0) {
      const ScopeKeys = selectedCheckboxRows.map(row => row.lScopeKey).join(',');
      const request = {
        plPendingContractKey: pendingContractId,
        psScopeKeys: ScopeKeys
      }
      addPendingContractScope(request);
    } else {
      ToastService.error("Please select at least one department to assign.");
    }
  }

  const handleAddRow = (rowData) => {
    if (rowData) {
      const request = {
        plPendingContractKey: pendingContractId,
        psScopeKeys: rowData?.lScopeKey.toString()
      }
      addPendingContractScope(request);
    }
  }

  const handleDeleteRow = (rowData) => {
    if (pendingContractId && rowData) {
      confirm(
        "Remove Scope?",
        "Are you sure you want to delete this scope?",
        "Delete",
        "Cancel"
      ).then((confirmed) => {
        if (confirmed) {
          deletePendingContractScope({ plPendingContractKey: pendingContractId, plScopeKey: rowData?.lScopeKey });
        }
      });
    }
  }

  const handleEditRow = (rowData) => {
    setIsModelOpen(true);
    setEditRowData(rowData);
  };

  const DeletePendingContractScopeType = (rowData) => {
    if (rowData?.lPendingContractScopeKey) {
      confirm(
        "Remove Scope?",
        "Are you sure you want to delete this scope?",
        "Delete",
        "Cancel"
      ).then((confirmed) => {
        if (confirmed) {
          deletePendingContractScopeType(rowData?.lPendingContractScopeKey)
        }
      });
    }
  };

  const handleAddSerialNumber = (rowData) => {
    if ((rowData?.lClientKey === 0 || rowData?.lClientKey === null) && (rowData?.lDepartmentKey === 0 || rowData?.lDepartmentKey === null)) {
      warning("Cannot add Serial Number", "No Client/Department - Cannot add Serial Number", "OK");
      return;
    }
    setIsCentralModel(true);
    setEditRowData(rowData);
  }

  const handleChangeSerialNumber = (dataField, value) => {
    setSerialNumber(value);
  }
  const handleCloseCentralModel = () => {
    setIsCentralModel(!isCentralModel);
    setSerialNumber("");
  }

  const handleSaveClick = async () => {
    if (serialNumber.trim() === 'TBD' || serialNumber.trim() === 'tbd') {
      warning("Invalid Serial Number", "Serial Number cannot be 'TBD'", "OK");
      return;
    }
    if (editRowData && serialNumber) {
      let exist = await checkScopeSerialNumberExists(serialNumber);
      if (exist?.data?.serialNumberExists === true) {
        confirm(`Serial ${serialNumber} Number already exists`, " Do you wish to add a new scope with this number?", "Yes", "No")
          .then((confirmed) => {
            if (confirmed) {
              pendingContractScopeEditSerialNumber({ plPendingContractScopeKey: editRowData?.lPendingContractScopeKey, psSerialNumber: serialNumber });
            }
          });
      }
      else {
        pendingContractScopeEditSerialNumber({ plPendingContractScopeKey: editRowData?.lPendingContractScopeKey, psSerialNumber: serialNumber });
      }
    }
  }

  const getCtxMenuItems = (row) => {
    if (!row) return [];
    const isNew = row.lScopeKey === 0 || row.lScopeKey === null;

    return isNew
      ? [
        {
          label: "Edit",
          command: () => handleEditRow(row),
        },
        {
          label: "Add Serial #",
          command: () => handleAddSerialNumber(row),
        },
        {
          label: "Remove",
          command: () => DeletePendingContractScopeType(row),
        }
      ]
      : [
        {
          label: "Remove",
          command: () => handleDeleteRow(row),
        },
      ];
  };


  const getCtxMenuItems1 = (row) => {
    if (!row) return [];
    return [
      {
        label: "Add",
        command: () => handleAddRow(row),
      },
    ];
  }

  const handalModelOpen = () => {
    setIsModelOpen(true);
  };
  const handleCloseModel = () => {
    setIsModelOpen(!isModelOpen);
    setEditRowData(null);
  };
  return (
    <>
      <div className="row gap-4">
        <div className="scrollable-grid col-12">
          <CardSection
            cardTitle="Covered Scopes"
            rightButton={true}
            isButtonVisible={true}
            buttonClassName="btn blue-btn w-full"
            titleButtonClick={handalModelOpen}
            buttonText="Add Scopes"
          >
            <MolGrid
              value={contractScopesData}
              grouping
              expandableRowGroups={true}
              paginator={false}
              scrollable
              scrollHeight="flex"
              filterDisplay="row"
              sortMode="single"
              showGridlines
              resizableColumns
              ctxMenuItems={getCtxMenuItems}
            >
              <Column
                field="sClientName1"
                header="Client"
                grouping
                sortable
                style={{ width: "18%" }}
              />

              <Column
                field="sDepartmentName"
                header="Department"
                grouping
                sortable
                style={{ width: "18%" }}
              />
              <Column
                field="sScopeTypeDesc"
                header="Model"
                grouping
                sortable
                style={{ width: "18%" }}
              />
              <Column
                field="sSerialNumber"
                header="Serial#"
                grouping
                sortable
                style={{ width: "12%", textAlign: "center" }}
              />
              <Column
                field="nUnitCost"
                header="Unit Cost"
                colType="money"
                grouping
                sortable
                style={{ width: "12%", textAlign: "right" }}
              />
              <Column
                field="lQuantity"
                header="Quantity"
                grouping
                sortable
                style={{ width: "10%", textAlign: "center" }}
              />
              <Column
                field="nContractCost"
                header="cost"
                colType="money"
                grouping
                sortable
                style={{ width: "12%", textAlign: "right" }}
              />
            </MolGrid>
          </CardSection>
        </div>
        <div className="center-btn">
          <Buttons
            isIcon={true}
            iconClass="bxs:up-arrow"
            onClick={handleAssignClick}
            buttonTypeClassName="btn blue-btn"
            titleText="Assign Selected Items"
            isDisable={selectedCheckboxRows.length === 0}
          // isLoading={isDeleting}
          />
        </div>
        <div className="scrollable-grid col-12 available-department">
          <CardSection cardTitle="Available Scopes">
            <MolGrid
              grouping
              value={availableScopesData}
              expandableRowGroups={true}
              paginator={false}
              scrollable
              scrollHeight="flex"
              filterDisplay="row"
              sortMode="single"
              showGridlines
              resizableColumns
              ctxMenuItems={getCtxMenuItems1}
              selection={selectedCheckboxRows}
              onSelectionChange={(e) => setSelectedCheckboxRows(e.value)}
              dataKey="lScopeKey"
            >
              <Column
                selectionMode="multiple"
                bodyStyle={{ textAlign: "center" }}
              />
              <Column
                field="sClientName1"
                header="Client"
                grouping
                sortable
                style={{ width: "20%" }}
              />

              <Column
                field="sDepartmentName"
                header="Department"
                grouping
                sortable
                style={{ width: "20%" }}
              />
              <Column
                field="sScopeTypeDesc"
                header="Model"
                grouping
                sortable
                style={{ width: "20%" }}
              />
              <Column
                field="sSerialNumber"
                header="Serial#"
                grouping
                sortable
                style={{ width: "15%", textAlign: "center" }}
              />

              <Column
                field="nContractCost"
                header="Cost"
                grouping
                sortable
                colType="money"
                style={{ width: "15%", textAlign: "right" }}
              />
            </MolGrid>
          </CardSection>
        </div>
      </div>
      <CustomCenterModel
        isOpen={isModelOpen}
        useCustomBg={true}
        modalTitle={`${editRowData ? 'Edit' : 'Add'} Pending Contract Scope`}
        contentClass="content-50"
        onClose={handleCloseModel}
        modalTitleIcon={AppIcons.AddIcon}
      >
        <AddPendingContractScopes
          onClose={handleCloseModel}
          editRowData={editRowData}
          getPendingContractScopes={getPendingContractScopes}
        />
      </CustomCenterModel>
      <CustomCenterModel
        isOpen={isCentralModel}
        useCustomBg={true}
        modalTitle={`Add Serial Number`}
        contentClass="content-30"
        onClose={handleCloseCentralModel}
        modalTitleIcon={AppIcons.AddIcon}
      >
        <FormInputFields
          dataField="sSerialNumber"
          labelName="Serial Number"
          name="sSerialNumber"
          type="text"
          value={serialNumber}
          isRequired={true}
          onChange={handleChangeSerialNumber}
          fieldSetting={{
            placeholder: "Enter Serial Number",
          }}
        />
        <div className="col-12 mt-3 d-flex justify-content-center button-submit">
          <Buttons
            buttonText="Save"
            buttonTypeClassName="btn blue-btn w-full"
            onClick={handleSaveClick}
          // isLoading={isClientAdding}
          />
          <Buttons
            buttonText="Cancel"
            buttonTypeClassName="btn secondary-btn ml-4"
            onClick={() => setIsCentralModel(!isCentralModel)}
          // isLoading={isClientAdding}
          />
        </div>
      </CustomCenterModel>
    </>
  );
};

export default Scopes;
